import { KrCard } from '@/common/card/KrCard';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityAuditCard } from '@/common/form/cards/EntityAuditCard';
import { EntitySectionCard } from '@/common/form/cards/EntitySectionCard';
import { EntityStatusCard } from '@/common/form/cards/EntityStatusCard';
import { ScrollableSpacerLayoutArea } from '@/common/layout/ScrollableSpacerLayoutArea';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { EventList } from '@/skdr/entities/event/EventList';

export const RunForm = () => {
  const { entityObj } = useEntityMgr();

  return (
    <EntityForm>
      <SpacerLayout>
        <Spacer weights={[3, 1]}>
          <ScrollableSpacerLayoutArea>
            <EntitySectionCard title="General" />
            <KrCard title="Events" variant="soft" fill>
              <EventList runId={entityObj.id} />
            </KrCard>
          </ScrollableSpacerLayoutArea>
          <ScrollableSpacerLayoutArea>
            <EntityStatusCard />
            <EntityAuditCard />
          </ScrollableSpacerLayoutArea>
        </Spacer>
      </SpacerLayout>
    </EntityForm>
  );
};
